import React from 'react';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { updateProduct } from '../../API/product';
import { floatValidation } from '../../../utils/formikValidations';
import { convertToFloat } from '../../../utils/string';
import { formatNumber } from '../../../utils/number';
import { Field } from 'formik';
import * as yup from 'yup';
import messages from '../../../messages';
import Step from '../BuildingBlocks/Stepper/Step';
import FloatFormatTextField from '../../misc/FloatFormatTextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import cloneDeep from 'lodash.clonedeep';
import ProductDetails from './product-details/ProductDetails';

export default function ProductPrice() {
  const snackbar = useSnackbarContext();
  const { trackEvent } = useEventTrackerContext();
  const { setLoading, goForward } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();

  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { price: string }) {
    let price = convertToFloat(values.price);
    if (!newestProduct) {
      return snackbar.show(messages.product.errors.notFoundUpdate, 'error');
    }
    try {
      if (newestProduct?.msrp !== price) {
        setLoading(true);
        await updateProduct(newestProduct?.id, {
          msrp: price,
        });
        const updatedProducts = cloneDeep(products).map((product) => {
          if (product.id === newestProduct.id) {
            product['msrp'] = price;
          }
          return product;
        });
        setProducts(updatedProducts);
      }
      trackEvent({ event: 'entered_average_price', average_price: price });
      goForward();
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{
        price: newestProduct?.msrp ? formatNumber(newestProduct.msrp) : '',
      }}
      validationSchema={yup.object({
        price: floatValidation,
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <ProductDetails product={newestProduct} step={5}>
            <Field
              name="price"
              label="Product Price"
              component={FloatFormatTextField}
              variant="outlined"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AttachMoneyIcon />
                  </InputAdornment>
                ),
              }}
            />
          </ProductDetails>
        );
      }}
    />
  );
}
